import { atom } from "jotai";
import { isGeneratingExplanationAtom } from "./tourStateAtoms";
import { nodeIdToExplainAtom } from "./tourStateAtoms";
import { nodeAtomFamily } from "../nodes";

/**
 * Reusable setter for explaining nodes
 * Encapsulates the logic for preparing and submitting node explanation requests
 */
export const explainNodeSetter = atom(
  null,
  (
    get,
    set,
    params: {
      copilot: any;
      nodeId: string;
    },
  ) => {
    const { copilot, nodeId } = params;
    // Validate copilot availability
    if (!copilot) {
      console.error("copilot not available");
      return Promise.reject(new Error("copilot not available"));
    }
    const nodeToExplain = get(nodeAtomFamily(nodeId));
    if (!nodeToExplain) {
      console.error("Node to explain not found:", nodeId);
      return Promise.reject(new Error(`Node to explain not found: ${nodeId}`));
    }

    // Set both states: generation for loading, nodeId for toolbar hiding
    set(isGeneratingExplanationAtom, true);
    set(nodeIdToExplainAtom, nodeId);

    try {
      copilot.append({
        role: "user",
        content: `Use the explain_node tool to explain node ${nodeToExplain.id}`,
      });
      return Promise.resolve();
    } catch (error) {
      console.error("Failed to explain node:", error);
      set(isGeneratingExplanationAtom, false);
      set(nodeIdToExplainAtom, null);
      return Promise.reject(error);
    }
  },
);

explainNodeSetter.debugLabel = "explainNodeSetter";
